export default __webpack_public_path__ + "static/media/gamecare.162a0fd4.svg";